import { useEffect } from 'react';
import { useNotificationPermission } from '../hooks';

export default function NotificationProvider({ children }) {
    const permission = useNotificationPermission()
    
    useEffect(() => {
        if (permission === "granted") {
            // console.log('listening')
        }
    }, [permission])

    return children
}
